export default __webpack_public_path__ + "static/media/ACK_RECEPT_APPLICATION.cfdc0361.png";